@use '@fukuri-admins/ui/layout' as *;

.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: spacing('8');
  white-space: nowrap;
  border-radius: borderRadius('lg');
  border: none;

  // 基本的なフォントスタイル
  color: text('High');
  @include typography('Jp/14_Button');

  cursor: pointer;
  text-decoration: none;
  svg {
    color: currentColor;
  }

  &:disabled {
    pointer-events: none;
  }

  &.primary {
    color: text('White');
    background-color: background('Gray_Darken');

    &:hover:not(:disabled) {
      background: linear-gradient(
        0deg,
        background('Overlay_Wh_10') 0%,
        background('Overlay_Wh_10') 100%
      ), background('Gray_Darken');
    }

    &:focus-visible:not(:disabled) {
      outline: none;
      box-shadow: 0 0 0 3px border('Focus');
    }

    &:active:not(:disabled) {
      background: linear-gradient(
        0deg,
        background('Overlay_Wh_40') 0%,
        background('Overlay_Wh_40') 100%
      ), background('Gray_Darken');
    }

    &:disabled {
      background: linear-gradient(
        0deg,
        background('Overlay_Wh_50') 0%,
        background('Overlay_Wh_50') 100%
      ), background('Gray_Darken');
    }
  }
  &.secondary {
    background-color: background('Secondary');

    &:hover:not(:disabled) {
      background: linear-gradient(
        0deg,
        background('Overlay_Wh_20') 0%,
        background('Overlay_Wh_20') 100%
      ), background('Secondary');
    }

    &:focus-visible:not(:disabled) {
      outline: none;
      box-shadow: 0 0 0 3px border('Focus');
    }

    &:active:not(:disabled) {
      color: text('High60');
      background: linear-gradient(
        0deg,
        background('Overlay_Wh_40') 0%,
        background('Overlay_Wh_40') 100%
      ), background('Secondary');
    }

    &:disabled {
      color: text('High50');
      background: linear-gradient(
        0deg,
        background('Overlay_Wh_50') 0%,
        background('Overlay_Wh_50') 100%
      ), background('Secondary');
    }
  }
  &.destructive {
    color: text('White');
    background-color: background('Red_Darken');

    &:hover:not(:disabled) {
      background: linear-gradient(
        0deg,
        background('Overlay_Wh_10') 0%,
        background('Overlay_Wh_10') 100%
      ), background('Red_Darken');
    }

    &:focus-visible:not(:disabled) {
      outline: none;
      box-shadow: 0 0 0 3px border('Focus');
    }

    &:active:not(:disabled) {
      background: linear-gradient(
        0deg,
        background('Overlay_Wh_40') 0%,
        background('Overlay_Wh_40') 100%
      ), background('Red_Darken');
    }

    &:disabled {
      background: linear-gradient(
        0deg,
        background('Overlay_Wh_50') 0%,
        background('Overlay_Wh_50') 100%
      ), background('Red_Darken');
    }
  }
  &.outline {
    background-color: background('Primary');
    border: 1px solid border('Quaternary');

    &:hover:not(:disabled) {
      background-color: background('Secondary');
    }

    &:focus-visible:not(:disabled) {
      outline: none;
      box-shadow: 0 0 0 3px border('Focus');
    }

    &:active:not(:disabled) {
      color: text('High60');
    }

    &:disabled {
      color: text('High50');
    }
  }
  &.ghost {
    background-color: transparent;

    &:hover:not(:disabled) {
      background-color: background('Secondary');
    }

    &:active:not(:disabled) {
      color: text('High60');
    }

    &:disabled {
      color: text('High50');
    }
  }
  &.ghostDestructive {
    color: text('Red');
    background-color: transparent;

    &:hover:not(:disabled) {
      background-color: background('Overlay_Bl_5');
    }

    &:focus-visible:not(:disabled) {
      outline: none;
      box-shadow: 0 0 0 3px border('Focus');
    }

    &:active:not(:disabled) {
      color: text('Red60');
      background-color: transparent;
    }

    &:disabled {
      color: text('Red50');
    }
  }

  &.md {
    min-width: 64px;
    padding: spacing('12') spacing('16');
  }
  &.xs {
    min-width: 64px;
    @include typography('Jp/12_Button');

    padding: spacing('4') spacing('8');
  }
  &.sm {
    min-width: 64px;
    @include typography('Jp/12_Button');

    padding: spacing('8') spacing('12');
  }
  &.lg {
    min-width: 80px;
    padding: spacing('16') spacing('24');
  }

  &.fullWidth {
    width: 100%;
  }
}
